module.exports = __webpack_public_path__ + "img/indigo3.492d3096.png";